import React from 'react'
import styles from './Style.module.css'
import { Calendar, Clock, UserIcon } from 'lucide-react'
import { useWebSettings } from '../../Context/WebSettings/WebSettingsContext';

const TermsAndConditions = () => {
  const { rescheduleTimeLimit } = useWebSettings();
  return (
    <div className={`${styles.termAndConditionCard} container-md space-y space-x`}>
        <h2 className={`${styles.titleSub} section-title`}>Booking Etiquette</h2>
          <div className={styles.item}>
            <div className={styles.icon}><Calendar size={20} color="#7F4055" /></div>
            <div className={styles.right}>
              <h6>Plans changed? We get it, life happens!</h6>
              <p>Online changes are only available up to {rescheduleTimeLimit} {rescheduleTimeLimit === 1 ? 'hour' : 'hours'} before the appointment. Contact the outlet directly for urgent requests. Thank you for respecting our therapists’ time.</p>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}><Clock size={20} color="#7F4055" /></div>
            <div className={styles.right}>
              <h6>Show up early for registration</h6>
              <p>Arriving more than 15 minutes late will result in a no-show or a shortened service.</p>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}><UserIcon size={20} color="#7F4055" /></div>
            <div className={styles.right}>
              <h6>Member and Non-Member rates</h6>
              <p>Members enjoy exclusive rates. Approach our friendly receptionists to know more about our membership promotions.</p>
            </div>
          </div>
    </div>
  )
}

export default TermsAndConditions
